<div class="container-fluid">
  <div class="block-header">
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <ul class="breadcrumb breadcrumb-style ">
          <li class="breadcrumb-item">
            <h4 class="page-title">Social Media Posts</h4>
          </li>

        </ul>
      </div>
    </div>
  </div>
  <!-- Image Gallery -->
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"></div>
    <mat-tab-group *ngIf="instaImageObject.length>0 || fbImageObject.length>0">
      <mat-tab *ngIf="instaImageObject.length>0">
        <ng-template mat-tab-label><fa-icon [icon]="faInstagram"></fa-icon>&nbsp; Instagram</ng-template>
        <div *ngFor="let img of instaImageObject; let i = index">
          <img [src]="img.thumbImage || img.image" (click)="showLightbox(i)" />
          <p>{{img?.title}}</p>

          <!-- ng-image-fullscreen-view  -->
          <ng-image-fullscreen-view [images]="instaImageObject" [imageIndex]="currentIndex" [show]="showFlag"
            (close)="closeEventHandler()"></ng-image-fullscreen-view>

        </div>
      </mat-tab>
      <mat-tab *ngIf="fbImageObject.length>0">
        <ng-template mat-tab-label><fa-icon [icon]="faFacebook"></fa-icon>&nbsp; Facebook</ng-template>
        <div *ngFor="let img of fbImageObject; let i = index">
          <img [src]="img.image" (click)="showLightbox(i)" />
          <p>{{img?.title}}</p>
          <!-- ng-image-fullscreen-view  -->
          <ng-image-fullscreen-view [images]="fbImageObject" [imageIndex]="currentIndex" [show]="showFlag"
            (close)="closeEventHandler()"></ng-image-fullscreen-view>
        </div>
      </mat-tab>
    </mat-tab-group>


  </div>
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"
    *ngIf="(instaImageObject?.length==0 && fbImageObject?.length==0) && callFinished">
    <h3>Sorry we could not fetch any social posts.</h3>
  </div>
  <div class="col">
    <div class="d-flex justify-content-center align-items-center" *ngIf="!callFinished">
      <mat-spinner></mat-spinner>
    </div>
  </div>
</div>
